import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-ffc042cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-box" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-container-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "selected" }, "密码登录")
], -1))
const _hoisted_5 = { class: "link-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_copyright = _resolveComponent("ui-copyright")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ui_form, {
        class: "form-box",
        ref: "form"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_ui_form_item, {
            error: "请输入手机号",
            showError: false,
            required: true,
            data: _ctx.post.phone,
            class: "input-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.post.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.post.phone) = $event)),
                onKeydown: _withKeys(_ctx.submitEvent, ["native","enter"]),
                name: "phone",
                placeholder: "请输入手机号"
              }, null, 8, ["modelValue", "onKeydown"])
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(_component_ui_form_item, {
            error: "请输入密码",
            showError: false,
            required: true,
            data: _ctx.post.loginpwd,
            class: "input-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.post.loginpwd,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.post.loginpwd) = $event)),
                onKeydown: _withKeys(_ctx.submitEvent, ["native","enter"]),
                "show-password": "",
                name: "loginpwd",
                placeholder: "请输入密码"
              }, null, 8, ["modelValue", "onKeydown"])
            ]),
            _: 1
          }, 8, ["data"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "login-btn",
            size: "large",
            onClick: _ctx.submitEvent,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("登 录")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_link, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goto('/forgot'))),
              underline: false,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("忘记密码")
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _createVNode(_component_el_link, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goto('/register'))),
              underline: false,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("免费注册")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_ui_copyright)
  ]))
}